import { IMO } from '../models/voyage-imo-model';
import { authFetchPOST} from '../utils/auth-fetch';
import { statusData } from './types/status-service.types';  
import { VoyageImoModel } from '../models/voyage-imo-model'; 

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;
const statusApi = (<any>window)["appenv"].services.onlineStatusApi;
const env = { ...statusApi, ...isVesselOnCloud ? { scope: (<any>window)["appenv"].scope } : {} };


export class StatusService {

    static async setOnlineStatus(payload: statusData): Promise<string | null> {
        try {
            return await authFetchPOST(env.scope, `${env.baseurl}/OnlineStatus?imo=${VoyageImoModel?.imo}&isCloud=true`, payload);
        } catch (err) {
            console.warn('Error in recording latest heart beat', err);
            return null;
        }
    }
}
